// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"485":"b3c86ffe","665":"b93f2d0f","974":"ea915617"}[chunkId] + ".chunk.css";
};